import React from "react";
import PropTypes from "prop-types";
import {
  ADD_ICON,
  COPY_ICON,
  EDIT_ICON,
  VIEW_ICON,
} from "../../cufront-assets/icons/Icons";
import InputField from "./InputField";
import FilterComponent from "../../roles_and_permissions/components/FilterComponent";
import "../css/Table.css";
import { FaTrash } from "react-icons/fa6";

const Table = ({
  columns,
  data,
  onSearchChange,
  searchValue,
  isLoading,
  onAddClick,
  onEditClick,
  onViewClick,
  onCopyClick,
  filters,
  onFilterChange,
  onAddFilter,
  onRemoveFilter,
  navigation,
  onDelete,
  onDeleteClick,
}) => {
  return (
    <div className="cu-setup-table-container">
      <div className="cu-setup-table-search">
        <div className="cu-setup-table-create-icon" onClick={onAddClick}>
          <span>
            <img src={ADD_ICON} alt="add icon" />
          </span>
          <span>Create</span>
        </div>

        <div className="cu-setup-table-search-input">
          <InputField
            type="text"
            placeholder="Search"
            value={searchValue}
            search={true}
            onChange={onSearchChange}
            loading={isLoading}
          />
        </div>
      </div>
      {/* <div className="">
        {filters?.map((filter, index) => (
          <div className="my-4" key={index}>
            <FilterComponent
              key={index}
              index={index}
              filter={filter}
              onFilterChange={onFilterChange}
              onAddFilter={onAddFilter}
              onRemoveFilter={onRemoveFilter}
            />
          </div>
        ))}
      </div> */}

      <div className="cu-setup-table-2">
        <div className="relative overflow-x-auto">
          <table className="w-full table-auto border text-base text-left rtl:text-right">
            <thead className="text-sm text-[#6D6D6D] uppercase bg-gray-50">
              <tr>
                {columns?.map((col, index) => (
                  <th scope="col" className="px-24 py-3 border-b-2" key={index}>
                    {col.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.map((row, rowIndex) => (
                <tr className="bg-white border-b-2" key={rowIndex}>
                  {columns?.map((col, colIndex) => (
                    <>
                      {col.accessor == "name" && (
                        <th
                          scope="row"
                          key={colIndex}
                          onClick={
                            navigation && col.accessor === "name"
                              ? () => onViewClick(row.id)
                              : undefined
                          }
                          className={
                            navigation && col.accessor === "name"
                              ? "text-[#17A1FA] cursor-pointer px-24 py-4 font-medium whitespace-nowrap"
                              : "text-left px-24 py-4 font-medium text-[#000000] whitespace-nowrap"
                          }
                        >
                          {row[col.accessor]}
                        </th>
                      )}

                      {col.accessor == "description" && (
                        <td class="px-24 py-4 max-w-[50px]">
                          {" "}
                          {row[col.accessor]}
                        </td>
                      )}

                      {col.accessor == "action" && (
                        <td class="px-24 py-4 flex gap-2">
                          {" "}
                          {onEditClick && (
                            <img
                              src={EDIT_ICON}
                              alt="edit"
                              width={"15px"}
                              height={"15px"}
                              className="cursor-pointer"
                              onClick={() => onEditClick(row.id)}
                            />
                          )}
                          {onViewClick && (
                            <img
                              src={VIEW_ICON}
                              alt="view"
                              width={"20px"}
                              height={"15px"}
                              className="cursor-pointer"
                              onClick={() => onViewClick(row.id)}
                            />
                          )}
                          {onCopyClick && (
                            <img
                              src={COPY_ICON}
                              alt="copy"
                              width={"11.79px"}
                              height={"15px"}
                              className="cursor-pointer"
                              onClick={() => onCopyClick(row.id)}
                            />
                          )}
                          {onDeleteClick && (
                            <FaTrash
                              size={16}
                              color="gray"
                              
                              className="cursor-pointer"
                              onClick={() => onDeleteClick(row?.id)}
                            />
                          )}
                        </td>
                      )}
                    </>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* 
        <table>
          <thead className="cu-setup-table-header-2 table-auto">
            <tr>
              {columns?.map((col, index) => (
                <th
                  // style={{
                  //   textAlign: "left",
                  // }}
                  // className="text-left"
                  key={index}
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns?.map((col, colIndex) => (
                  <>
                    <td
                      // style={{
                      //   textAlign: "left",
                      // }}
                      key={colIndex}
                      onClick={
                        navigation && col.accessor === "name"
                          ? () => onViewClick(row.id)
                          : undefined
                      }
                      className={
                        navigation && col.accessor === "name"
                          ? "text-[#17A1FA] cursor-pointer tt"
                          : "text-left"
                      }
                    >
                      {row[col.accessor]}

                      {col.accessor === "action" && (
                        // <td
                        //   style={{
                        //     textAlign: "left",
                        //   }}
                        //   className="flex gap-2 justify-start"
                        // >
                        <span
                          style={{
                            textAlign: "left",
                          }}
                          className="flex justify-start gap-2 mr-96 pr-2"
                        >
                          {onEditClick && (
                            <img
                              src={EDIT_ICON}
                              alt="edit"
                              width={"15px"}
                              height={"15px"}
                              className="cursor-pointer"
                              onClick={() => onEditClick(row.id)}
                            />
                          )}

                          {onViewClick && (
                            <img
                              src={VIEW_ICON}
                              alt="view"
                              width={"20px"}
                              height={"15px"}
                              className="cursor-pointer"
                              onClick={() => onViewClick(row.id)}
                            />
                          )}

                          {onCopyClick && (
                            <img
                              src={COPY_ICON}
                              alt="copy"
                              width={"11.79px"}
                              height={"15px"}
                              className="cursor-pointer"
                              onClick={() => onCopyClick(row.id)}
                            />
                          )}
                        </span>
                        // </td>
                      )}
                    </td>
                  </>
                ))}
                <td>
                  <div className="cu-setup-table-action-col"></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}
      </div>
    </div>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSearchChange: PropTypes.func,
  searchValue: PropTypes.string,
  isLoading: PropTypes.bool,
  onAddClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onViewClick: PropTypes.func,
  onCopyClick: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.object),
  onFilterChange: PropTypes.func,
  onAddFilter: PropTypes.func,
  onRemoveFilter: PropTypes.func,
};

export default Table;
